import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import {
  IEmailState,
  IPhoneNumberState,
} from "@/apps/person-registration/models/IContactInfoState";
import { IState } from "@/apps/person-registration/models/IState";
import { IIdentificationState } from "@/apps/person-registration/models/IIdentificationState";
import { IImageFeedbackState } from "@/apps/person-registration/models/IImageFeedbackState";

export default {
  namespaced: true,
  state: {
    location: null,
    userType: null,
    userTag: null,
    versionHash: null,
    personCreated: null,
    privacyPolicyAccepted: false,
    hasFrontId: false,
    hasBackId: false,
    hasSelfie: false,
    inManualReview: false,
    cxQueuePosition: null,
    cxQueuePositionLimit: 4,
    isCxTicketAssigned: false,
    skipEmailInput: false,
    skipPhoneInput: false,
    hideCancelButton: false,
    incodeRedirectionUrl: false,
    messagesBag: {
      front: [] as IImageFeedbackState[],
      back: [] as IImageFeedbackState[],
      selfie: [] as IImageFeedbackState[],
      bottomPage: [] as IImageFeedbackState[],
      cxCorrection: [] as IImageFeedbackState[],
    },
    actionablePage: null,
    settings: null,
    externalUrlAfterCompletion: null,
    captureFlow: null,
    captureFlowCompleted: null,
    emailVerification: {
      email: null,
      previouslyVerifiedEmail: null,
      isPreviouslyVerifiedEmailFound: false,
      registrantOptedToUsePreviouslyVerifiedEmail: false,
      isEmailVerified: false,
    },
    phoneVerification: {
      phoneNumber: null,
      previouslyVerifiedPhone: null,
      isPreviouslyVerifiedPhoneFound: false,
      registrantOptedToUsePreviouslyVerifiedPhone: false,
      isPhoneVerified: false,
    },
    userData: {
      privacyPolicyAccept: null,
      frontImageURL: null,
      backImageURL: null,
      selfieImageURL: null,
      phoneNumber: {
        createdAt: null,
        phoneNumber: null,
        phoneNumberVerifiedAt: null,
        updatedAt: null,
      } as unknown as IPhoneNumberState,
      email: {
        createdAt: null,
        email: null,
        emailVerifiedAt: null,
        updatedAt: null,
      } as unknown as IEmailState,
      phoneVerify: null,
      country: null,
      originatingCountry: null,
      identifications: [{} as IIdentificationState],
    },
  } as IState,

  mutations,
  actions,
  getters,
};
